<mat-toolbar class="header">
    <div class="menu-container">
        <button mat-icon-button (click)="drawerService.toggle()">
            <mat-icon>menu</mat-icon>
        </button>
        <span class="page-title" fxFlex>{{title}}</span>
    </div>
</mat-toolbar>
